import React from 'react';
import PropTypes from 'prop-types';
import { ExclamationCircleFilled } from '@ant-design/icons';
import { depositType } from '~constants';
import { Icon, Tooltip } from 'antd';

export default class DepositTTL extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      allType: [],
    };
  }

  componentDidMount() {
    if (this.props.paymentDepositRules) {
      this.getPropertyDepositType();
    }
  }

  getPropertyDepositType = () => {
    const types = [];
    const locale = this.props.locale;
    this.props.paymentDepositRules?.edges
      ?.filter(deposit => deposit.node[locale === 'CN' ? 'effectiveCn' : 'effectiveRow'])
      .map(deposit => {
        if (types.indexOf(deposit.node.type) === -1) {
          types.push(deposit.node.type);
        }
        return true;
      });

    this.setState({ allType: types });
  };

  depositFormula = () => {
    const types = this.state.allType;
    if (types.length === 1) {
      if (types.indexOf(depositType.FIXED_AMOUNT) !== -1) {
        return '= F';
      }
      if (types.indexOf(depositType.PER_BILLING_CYCLE) !== -1) {
        return '= B';
      }
    }

    if (types.length === 2) {
      if (
        types.indexOf(depositType.DEPOSIT_PERCENTAGE) !== -1 &&
        types.indexOf(depositType.FIXED_AMOUNT) !== -1
      ) {
        return '= (1+P)*F';
      }
      if (
        types.indexOf(depositType.PER_BILLING_CYCLE) !== -1 &&
        types.indexOf(depositType.FIXED_AMOUNT) !== -1
      ) {
        return '= F+B';
      }
      if (
        types.indexOf(depositType.DEPOSIT_PERCENTAGE) !== -1 &&
        types.indexOf(depositType.PER_BILLING_CYCLE) !== -1
      ) {
        return '= (1+P)*B';
      }
    }

    if (types.length === 3) {
      return '= (1+P)*(F+B)';
    }

    return '';
  };

  render() {
    const { t, locale } = this.props;
    const { allType } = this.state;

    return (
      <div className="deposit-and-fees__ttl">
        <div className="deposit-and-fees__ttl-content">
          <Choose>
            <When condition={allType.length === 1 && allType[0] === depositType.DEPOSIT_PERCENTAGE}>
              <ExclamationCircleFilled
                className="deposit-and-fees__warning-icon"
                style={{ color: '#F5A623' }}
              />
              <span className="deposit-and-fees__ttl-deposit-text">
                &nbsp;&nbsp;
                {t('cms.deposit_and_fees.content_ttl.deposit_only_percentage_type.tips')}
              </span>
            </When>
            <When condition={allType.length === 0}>
              <span className="deposit-and-fees__ttl-deposit-text">
                {t('cms.deposit_and_fees.content_ttl.deposit.tips', { locale })}
              </span>
            </When>
            <Otherwise>
              <div>
                <div>
                  <span className="deposit-and-fees__ttl-deposit-text">
                    {t('cms.deposit_and_fees.content_ttl.deposit.ttl_amount')}
                  </span>
                  <Tooltip
                    overlayClassName="deposit-and-fees__ttl__formula-tooltip"
                    title={
                      <div className="deposit-and-fees__ttl-formula">
                        <span className="deposit-and-fees__ttl-formula-text">
                          <span className="deposit-and-fees__type-abbreviation">F</span>
                          {t('cms.deposit_and_fees.ttl_formula_textl.fixed')}
                        </span>
                        <span className="deposit-and-fees__ttl-formula-text">
                          <span className="deposit-and-fees__type-abbreviation">P</span>
                          {t('cms.deposit_and_fees.ttl_formula_textl.percentage')}
                        </span>
                        <span className="deposit-and-fees__ttl-formula-text">
                          <span className="deposit-and-fees__type-abbreviation">B</span>
                          {t('cms.deposit_and_fees.ttl_formula_textl.billing_cycle')}
                        </span>
                      </div>
                    }
                  >
                    <Icon type="question-circle" />
                  </Tooltip>
                </div>
                <span className="deposit-and-fees__ttl-deposit-text--amount">
                  {this.depositFormula()}
                </span>
              </div>
            </Otherwise>
          </Choose>
        </div>
      </div>
    );
  }
}

DepositTTL.propTypes = {
  t: PropTypes.func.isRequired,
  paymentDepositRules: PropTypes.object,
  locale: PropTypes.string.isRequired,
};

DepositTTL.defaultProps = {
  t: () => {},
  paymentDepositRules: {},
  locale: '',
};
